import { SQLGeneratedProcess } from "@avenueops/shared-types";
import { useSelected } from "context/BulkActionsContext";

interface Props {
  row: SQLGeneratedProcess;
}

export function Checkbox({ row }: Props) {
  const [selected, setSelected] = useSelected(row.id);
  return (
    <div
      className="flex w-full justify-center"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setSelected(!selected);
      }}
    >
      <input
        type="checkbox"
        className="form-checkbox h-4 w-4 flex place-self-center flex-none rounded-sm border border-gray-300 hover:border-primary-main hover:border-2 checked:text-primary-dark cursor-pointer"
        checked={selected}
        onChange={() => undefined}
        onClick={(e) => {
          e.stopPropagation();
          setSelected(!selected);
        }}
      />
    </div>
  );
}
